import { render, staticRenderFns } from "./zzmx.vue?vue&type=template&id=2a49dc30&scoped=true&"
import script from "./zzmx.vue?vue&type=script&lang=js&"
export * from "./zzmx.vue?vue&type=script&lang=js&"
import style0 from "./zzmx.vue?vue&type=style&index=0&id=2a49dc30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49dc30",
  null
  
)

export default component.exports